export default [
    "zh-CN", "en-US"
] as const;